/**
 * Module dependencies.
 */

import React from 'react';
import { Button } from '../../button/button';
import { cn } from 'app/lib/utils';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  loading?: boolean;
  label: string;
  disabled?: boolean;
  type?: 'ghost';
  onClick?: () => any;
  value?: string;
};

/**
 * Export `SubmitButton` component.
 */

export function SubmitButton({ className, disabled, onClick, loading, label, type, value }: Props): JSX.Element {
  return (
    <div className={cn('mt-8', className)}>
      <Button
        disabled={disabled}
        htmlType={'submit'}
        loading={loading}
        onClick={onClick}
        type={type ?? 'primary'}
        value={value}
      >
        {label}
      </Button>
    </div>
  );
}
